import http from '@/http'
import createCrudModule from 'vuex-crud'
import { withDataFilter } from '@/store/index'

const store = createCrudModule({
  client: http,
  resource: 'complexes/placements-layouts',
  urlRoot: 'complexes/placements-layouts',

  state: {
    total: 0
  },

  parseList(response) {
    return Object.assign({}, response, {
      data: response.data.data,
      total: response.data.total
    })
  },

  onFetchListSuccess(state, response) {
    state.total = response.total
  },

  mutations: {
    updateComplete(state) {
      state.isUpdating = false
    }
  },

  actions: {
    update({ commit }, { id, data, config } = {}) {
      commit('updateStart')
      return http
        .post(`complexes/placements-layouts/${id}`, data, config)
        .then(res => {
          commit('updateSuccess', res)
          return res
        })
        .catch(err => {
          commit('updateError', err)
          return Promise.reject(err)
        })
    },

    sortFiles({ commit }, photos) {
      commit('updateStart')
      return http.post('files/sort-ref', { photos }).finally(() => {
        commit('updateComplete')
      })
    },

    removeFile({ commit }, hash) {
      commit('updateStart')
      return http
        .post('complexes/placements-layouts/files-delete', { hash })
        .finally(() => {
          commit('updateComplete')
        })
    }
  }
})

export default withDataFilter(store)
